<template>
	<div>
		<header
			id="encabezado"
			:style="value.estilos"
		>

			<div class="seccion" :style="value.sección.estilos" :class="value.sección.clases">
				<div>
					<columna v-for="(c, i) in value.sección.columnas" :key="`cpnnte-sccn-${i}${$root.aleatorio}`" v-model="value.sección.columnas[i]"></columna>
				</div>
			</div>

			<div style="position: absolute; bottom: 10px; left: 10px; background-color: white; padding: 0;">

				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" class="boton-menu">
							Maquetación de elementos
							<v-icon right dark>mdi-menu-down</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item
							@click="cambiarMaquetación('imagen', 'texto', null, null)"
							:style="{ 'color': maquetación === 'imagen,texto,,' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Imagen y texto (1/1)</v-list-item-title>
						</v-list-item>
						<v-list-item
							@click="cambiarMaquetación('imagen', 'texto', null, '2')"
							:style="{ 'color': maquetación === 'imagen,texto,,2' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Imagen y texto (1/2)</v-list-item-title>
						</v-list-item>
						<v-list-item
							@click="cambiarMaquetación('texto', 'imagen', null, null)"
							:style="{ 'color': maquetación === 'texto,imagen,,' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Texto e imagen (1/1)</v-list-item-title>
						</v-list-item>
						<v-list-item
							@click="cambiarMaquetación('texto', 'imagen', '2', null)"
							:style="{ 'color': maquetación === 'texto,imagen,2,' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Texto e imagen (2/1)</v-list-item-title>
						</v-list-item>
						<v-list-item
							@click="cambiarMaquetación('texto', null)"
							:style="{ 'color': maquetación === 'texto,,,' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Sólo texto</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>

				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" class="boton-menu">
							Tamaño de encabezado
							<v-icon right dark>mdi-menu-down</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item
							@click="cambiarAlto('normal')"
							:style="{ 'color': value.estilos.height === '300px' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Normal</v-list-item-title>
						</v-list-item>
						<v-list-item
							@click="cambiarAlto('grande')"
							:style="{ 'color': value.estilos.height === '500px' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Grande</v-list-item-title>
						</v-list-item>
						<v-list-item
							@click="cambiarAlto('portada')"
							:style="{ 'color': value.estilos.height === '100vh' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Portada</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>

				<v-btn @click="cambiarFondo = true" class="boton-menu">
					Imagen de fondo
					<v-icon right dark>mdi-pencil</v-icon>
				</v-btn>

				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" class="boton-menu">
							Color de texto
							<v-icon right dark>mdi-menu-down</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item
							@click="cambiarColorDeTexto('#fff')"
							:style="{ 'color': colorDeTexto === '#fff' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Blanco</v-list-item-title>
						</v-list-item>
						<v-list-item
							@click="cambiarColorDeTexto('#ccc')"
							:style="{ 'color': colorDeTexto === '#ccc' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Blanco opaco</v-list-item-title>
						</v-list-item>
						<v-list-item
							@click="cambiarColorDeTexto('#000')"
							:style="{ 'color': colorDeTexto === '#000' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Negro</v-list-item-title>
						</v-list-item>
						<v-list-item
							@click="cambiarColorDeTexto('#444')"
							:style="{ 'color': colorDeTexto === '#444' ? '#1867c0 !important' : '' }"
						>
							<v-list-item-title>Negro opaco</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>

			</div>

		</header>

		<v-dialog
      v-model="cambiarFondo"
      max-width="800"
    >
      <seleccionar-medio v-model="fondo" @hecho="cambiarFondo = false"></seleccionar-medio>
    </v-dialog>

	</div>

</template>

<script>

import SeleccionarMedio from '@/components/utilidades/SeleccionarMedio'
import ParteTexto from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Parte/ParteTexto'
import Columna from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Columna'

export default {
  name: 'Encabezado',

  data: () => ({
		cambiarFondo: false,
		maquetación: '',
		colorDeTexto: '',
		fondo: {
			tipo: 'imagen',
			ubicación: ''
		},
		opcionesTexto: {
			listaNoOrdenada: false,
			listaNumerada: false
		},
	}),

	components: {
		SeleccionarMedio,
		ParteTexto,
		Columna,
	},
	
	props: {
		value: {
			type: Object,
			required: true
		}
	},

	watch: {
		'fondo.ubicación': function(val) {
			if (val) {
				this.value.estilos['background-image'] = `url('${val}')`
				this.cambiarFondo = false
			} else {
				this.value.estilos['background-image'] = ''
			}
		}
	},

	methods: {
		cambiarAlto(v) {
			if (v === 'normal') {
				this.$set(this.value.estilos, 'height', '300px')
			} else if (v === 'grande') {
				this.$set(this.value.estilos, 'height', '500px')
			} else if (v === 'portada') {
				this.$set(this.value.estilos, 'height', '100vh')
			}
		},
		cambiarMaquetación(c1, c2, t1, t2) {
			let actual = JSON.parse(JSON.stringify(this.value.sección))
			let parteTextoActual = null
			let parteImagenActual = null
			for (let c of actual.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'texto' && !parteTextoActual) {
						parteTextoActual = p
					}
					if (p.tipo === 'imagen' && !parteImagenActual) {
						parteImagenActual = p
					}
				}
			}

			let col = {
				partes: [
					{
						tipo: '',
						clases: {},
						estilos: {},
					}
				],
				clases: {},
				estilos: {
					'flex-grow': '1'
				}
			}

			let C1 = JSON.parse(JSON.stringify(col))
			let C2 = null

			let asegurarParteTexto = function(C, parteActual) {
				C.estilos.display = 'flex'
				if (parteActual) {
					C.partes[0] = parteActual
				} else {
					C.partes[0].tipo = 'texto'
					C.partes[0].texto = ''
				}
			}

			let asegurarParteImagen = function(C, parteActual) {
				if (parteActual) {
					C.partes[0] = parteActual
				} else {
					C.partes[0].tipo = 'imagen'
					C.partes[0].ubicación = ''
					C.partes[0].clases = {contenida: true}
				}
			}

			if (c1 === 'texto') {
				asegurarParteTexto(C1, parteTextoActual)
			} else if (c1 === 'imagen') {
				asegurarParteImagen(C1, parteImagenActual)
			} else {
				console.error('error: 57329574395')
				return
			}

			if (c2 === 'texto') {
				C2 = JSON.parse(JSON.stringify(col))
				asegurarParteTexto(C2, parteTextoActual)
			} else if (c2 === 'imagen') {
				C2 = JSON.parse(JSON.stringify(col))
				asegurarParteImagen(C2, parteImagenActual)
			}

			if (t1 === '2') {
				C1.estilos['flex-grow'] = '2'
			}

			if (C2 && t2 === '2') {
				C2.estilos['flex-grow'] = '2'
			}

			this.value.sección.columnas = []
			this.value.sección.columnas.push(C1)
			if (C2) {
				this.value.sección.columnas.push(C2)
			}

			this.maquetación = `${c1},${c2 || ''},${t1 || ''},${t2 || ''}`
		},
		cambiarColorDeTexto(color) {
			for (let c of this.value.sección.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'texto') {
						this.$set(p.estilos, 'color', color)
					}
				}
			}
			this.colorDeTexto = color
		}
	}

};

</script>

<style scoped>

#encabezado {
	transition: all 100ms linear;
}

.boton-menu {
	text-transform: none;
	font-weight: 400;
	letter-spacing: normal;
	font-size: initial;
}

</style>